import store from '@/store'

export default function(to, from, next) {
    const campaign = store.getters['apiCampaign/campaign']

    if (to.name === 'sampling-index' && (!campaign || !campaign.token)) {
        return next({ name: 'no-sampling' })
    }

    return next()
}
